import { AuthService } from './../../service/auth.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faKey, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { AgentDto } from '../../service/dto';

export type LoginModeEnum =
	| 'CaptureUsername'
	| 'CapturePassword'
	| 'CaptureOtp'
	| 'ForgotPasswordOtp'
	| 'ForgotPasswordSetNew'
	| 'CaptureRegistrationOtp'
	| 'CaptureRegistrationDetails'
	| 'CaptureRegistrationPortrait'
	| 'CaptureRegistrationDocumentFront'
	| 'CaptureRegistrationDocumentBack'
	| 'PendingApproval'
	| 'Rejected'
	| 'Blocked'
	| 'BlockedOtp'
	| 'Suspended';


export class Callback {
	agent?: AgentDto;
	mode!: LoginModeEnum;
}
// Which modes belong to the two-step sign-in flow (kenya-restyle.md
// §3/§3b) and which step they count as. Everything else (registration,
// pending/blocked/rejected, forgot-password) has no step indicator.
const STEP_ONE_MODES: LoginModeEnum[] = ['CaptureUsername', 'CapturePassword'];
const STEP_TWO_MODES: LoginModeEnum[] = ['CaptureOtp'];

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	standalone: false
})
export class LoginComponent {
	mode: LoginModeEnum = 'CaptureUsername';
	agent?: AgentDto;
	constructor(private authService: AuthService) {
	}
	doUpdateState(input: Callback) {
		console.log("Change", input);
		this.mode = input.mode;
		this.agent = input.agent;
	}

	get showStepIndicator(): boolean {
		return STEP_ONE_MODES.includes(this.mode) || STEP_TWO_MODES.includes(this.mode);
	}
	get stepTwoActive(): boolean {
		return STEP_TWO_MODES.includes(this.mode);
	}

	// canSubmit(): boolean {
	// 	if (this.username?.length <= 3) {
	// 		return false;
	// 	}
	// 	if (this.password?.length <= 3) {
	// 		return false;
	// 	}
	// 	if (this.twoFactorToken?.length <= 3) {
	// 		return false;
	// 	}
	// 	return true;
	// }
	// submit() {
	// 	this.message = undefined;
	// 	this.authService.doAuthenticate(this.username, this.password, this.twoFactorToken).subscribe(item => {
	// 		if (item.success == false) {
	// 			this.message = item.message;
	// 		}
	// 	});
	// }
}
